import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { goToPage, reportDWH } from '../../EsimQrCodeBlockSlice';
import Support from '../../Partials/Support/Support';
import TextList from '../../Partials/TextList/TextList';
import { gtag4 } from '../../../../../utilities/analytics/tracking';

const VideoPage = (props) => {
    const [operatingSystem, setOperatingSystem] = useState('android');//android|ios

    useEffect(() => {
        gtag4({ event: 'EsimLine_Step2_QrActivateInfoVideoPage', step: '2', action: 'QrActivateInfoVideoPage' });
        props.reportDWH({ actionType: 'Instruction Movie Page', status: 'Ongoing', messageText: 'Instruction QR Movie Page - Display' });
    }, []);

    return (
        <div className='video-page-wrapper'>
            <div className='video-page'>
                <div className='title'> איך מפעילים את ה-eSIM <br /> עם קוד QR או קודי הפעלה</div>

                <div className='select-operating-system'>
                    <button className={`android-icon ${operatingSystem == 'android' ? 'selected' : ''}`} onClick={handleSelectAndroid}>אנדרואיד</button>
                    <button className={`ios-icon ${operatingSystem == 'ios' ? 'selected' : ''}`} onClick={handleSelectIos}>IOS</button>
                </div>

                <div className='video-wrapper'>
                    <iframe src={operatingSystem == 'android' ? props.esimActivateVideoAndroidUrl : props.esimActivateVideoIosUrl} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </div>

                <div className='link-wrapper'>
                    <a href='#' onClick={(e) => handleBackToInstructionsPage(e)}>חזרה להפעלה באמצעות קוד QR</a>
                </div>

                {
                    props.videoPageTextList.length > 0 &&
                    <>
                        <div className='seperator'></div>
                        <TextList textList={props.videoPageTextList} />
                    </>
                }

                <div className='seperator'></div>

                <Support />

            </div>
        </div>
    );

    function handleBackToInstructionsPage(e) {
        e.preventDefault();
        props.goToPage('instructionsPage');
    }

    function handleSelectAndroid() {
        setOperatingSystem('android');
    }

    function handleSelectIos() {
        setOperatingSystem('ios');
    }

};

const mapStateToProps = (state) => {
    return {
        videoPageTextList: state.esimQrCodeBlock.esimBlockData.videoPageTextList,
        esimActivateVideoAndroidUrl: state.esimQrCodeBlock.esimBlockData.esimActivateVideoAndroidUrl,
        esimActivateVideoIosUrl: state.esimQrCodeBlock.esimBlockData.esimActivateVideoIosUrl
    };
};

const mapDispatchToProps = {
    goToPage,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoPage);
